export default __webpack_public_path__ + "static/media/Group9184.3c7482a1.svg";